'use client'
import Script from 'next/script'
import { useCallback, useEffect, useRef, useState } from 'react'

export default function RoamDropInCalendarButton({ isActive = true }) {
  const initializedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)

  const initializeLobbyEmbed = useCallback((url) => {
    const parentElement = document.getElementById("roam-lobby")
    const roam = typeof window !== 'undefined' ? window.Roam : undefined
    if (!parentElement || typeof roam === 'undefined') return

    console.info('[Roam][TalkToExpert] Initializing lobby embed URL:', url)
    setIsLoading(true)
    roam.initLobbyEmbed({
      url,
      parentElement,
      lobbyConfiguration: "booking_only",
      accentColor: "#0059DC",
      theme: "light",
      onSizeChange: (width, height) => {
        // Keep the embed visible while allowing Roam to resize itself.
        parentElement.style.height = `${Math.max(height, 500)}px`
      },
    });

    // Roam may not fire an `onLoad` callback, so remove the loader
    // when the iframe appears in the container.
    const iframeCheck = window.setInterval(() => {
      if (parentElement.querySelector('iframe')) {
        setIsLoading(false)
        window.clearInterval(iframeCheck)
      }
    }, 150)

    // Fallback so the loader never blocks interaction indefinitely.
    window.setTimeout(() => {
      setIsLoading(false)
      window.clearInterval(iframeCheck)
    }, 4000)

    initializedRef.current = true
  }, [])

  useEffect(() => {
    if (
      isActive &&
      !initializedRef.current &&
      typeof window !== 'undefined' &&
      typeof window.Roam !== 'undefined'
    ) {
      initializeLobbyEmbed("https://ro.am/kingdom-kode/free-15")
    }

    if (!isActive) {
      setIsLoading(true)
    }
  }, [isActive, initializeLobbyEmbed])

  return (
    <>
       <div style={{ position: 'relative', minWidth: '320px', width: '100%', height: '100%' }}>
          {isLoading && (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#ffffff',
                zIndex: 0,
              }}
            >
              Loading calendar...
            </div>
          )}
          <div id="roam-lobby" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}></div>
       </div>
          <Script
            id="roam-lobby-script"
            strategy="afterInteractive"
            onLoad={() => {
              if (isActive && !initializedRef.current) {
                initializeLobbyEmbed("https://ro.am/kingdom-kode/free-15")
              }
            }}
          >
            {`
            // Script loaded, initialization handled in onLoad
            `}
          </Script>
    </>
  )
}